import { LmByggnadandamal } from 'models';

export const getAndamalString = (andamal: Array<LmByggnadandamal>) =>
  andamal
    ? andamal
        .map(
          (andamal: LmByggnadandamal) => `${andamal.huvudandamaltyp}${andamal.andamal ? ', ' + andamal.andamal : ''}`
        )
        .join(', ')
    : undefined;
